import React, { useState } from 'react'
import { faqsData } from '../constant/Data';
import { BiChevronDown } from 'react-icons/bi';

const FAQs = () => {
    const [openIndex, setOpenIndex] = useState(null);

    return (
        <section className="mt-20 py-20 bg-gradient-to-br from-[#092A53] to-[#617DA0] text-white" id="faqs">
            <div className="max-w-7xl mx-auto px-4">
                <h2 className="text-3xl font-bold text-center mb-12">
                    Frequently Asked Questions
                </h2>
                <div className=" space-y-4">
                    {faqsData.map((faq, index) => (
                        <details
                            key={index}

                            class="group rounded-xl border border-gray-200 bg-gray-50 p-4">
                            <summary class="flex cursor-pointer list-none items-center justify-between"
                                onClick={() => setOpenIndex(openIndex === index ? null : index)}>
                                <p class="font-semibold text-base text-black">{faq.question}</p>
                                <span class="transition group-open:rotate-180">
                                    <svg fill="none" height="24" shape-rendering="geometricPrecision" stroke="black" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" viewBox="0 0 24 24" width="24">
                                        <path d="M6 9l6 6 6-6"></path>
                                    </svg>
                                </span>
                            </summary>
                            <p class="group-open:animate-fadeIn text-neutral-600 mt-3 text-xs font-normal"> {faq.answer}</p>
                        </details>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default FAQs
